import { StoreEntityType } from 'ngx-unificator/store';

export interface Xmas {
  page: XmasPage;
  currentBonus: CurrentBonusItem;
  currentSleighItemIndex: number;
  currentSleighItem: SleighDataItem;
  currentPrize: CurrentPrizeItem;
  sleighData: SleighDataItem[];
  defaultSleighArray: number[];
  isUserCanParticipateInPromo: boolean;
  isUserCanPartiallyParticipateInPromo: boolean;
  isUserAlreadyActivatedPromoLootbox: boolean;
  isSpinBonus: boolean;
  isWeeklyMissionsCompleted: boolean;
  isLoadedPromo: boolean;
  showTryTomorrowOnDestroy: boolean;
  isWelcomeModalOpened: boolean;
}

export interface XmasPage {
  Title: string;
  Description: string;
  SleighPrize: string;
  SleighRule: string;
  SleighPrizeTitle: string;
  SleighWeeklyPrizeDesc: string;
  ScoredLootboxTitle: string;
  WinLootboxTitle: string;
  WinSImpleBonusTitle: string;
  WinInformerTitle: string;
  Prizes: { prize: number | string }[];
  HowWorksTitle: string;
  HowWorksSteps: { title: string, desc: string }[];
  GamesTitle: string;
  GamesDesc: string;
  TournamentsTitle: string;
  HowWorksTerms: string;
  GeneralTerms: string;
  SleighData: SleighDataItem[];
  unpublishAt: any;
  publishAt: any;
  StartPromoDate: any;
  SecretFuelModalFirstTitle: string;
  SecretFuelModalSecondTitle: string;
  OpenLootboxTitle: string;
  TryTomorrowTitle: string;
  OtherPromotionsTitle: string;
  WeeklyMissionTitle: string;
  VisitAccountTitle: string;
  MetaTitle: string;
  MetaDesc: string;
  SeoContent: string;
  isDisablePromo?: boolean;
  OfferDesc?: string;
}

export interface CurrentBonusItem {
  fs?: any;
  cash?: any;
  welcomeLootbox?: any;
  promoLootbox?: any;
}

export interface CurrentPrizeItem {
  fs_count?: number;
  cash?: any;
}

export interface SleighDataItem {
  date: string;
  short_date: string;
  locked?: boolean;
  taken?: boolean;
  currentDayIndex?: boolean;
}

export const xmasStore: StoreEntityType<Xmas> = {
  defaultSleighArray: [1, 2, 3, 4, 5, 6, 7, 8]
    .flatMap((item, index, array) =>
      (index === array.length - 1 ? Array(3).fill(item) : Array(4).fill(item))),
  page: null,
  sleighData: null,
  currentSleighItemIndex: null,
  currentSleighItem: null,
  currentBonus: null,
  currentPrize: null,
  isUserCanParticipateInPromo: false,
  isUserCanPartiallyParticipateInPromo: false,
  isUserAlreadyActivatedPromoLootbox: false,
  isSpinBonus: false,
  isWeeklyMissionsCompleted: false,
  isLoadedPromo: false,
  isWelcomeModalOpened: false,
  showTryTomorrowOnDestroy: false,
};

export type XmasStoreEntity = typeof xmasStore;
